import { VERUM_LOGO } from "@/constants";
import { buildCharacterFrames } from "@/utils/buildCharacterFrames";

const CHAR_DELAY_STEP = 0.08;

const HandwrittenText = ({ text, baseDelay = 0, className = "" }) => (
  <span className={`hw-text-container ${className}`}>
    {buildCharacterFrames(text).map((frame, index) => (
      <span 
        key={frame.id} 
        className="hw-char" 
        style={{ animationDelay: `${baseDelay + index * CHAR_DELAY_STEP}s` }}
      >
        {frame.char === ' ' ? '\u00A0' : frame.char}
      </span>
    ))}
  </span>
);

const HeroSection = ({ loaded }) => (
  <section className={`verum-section ${loaded ? 'fade-in' : ''}`} data-testid="verum-section">
    <div className="verum-content">
      <div className="company-block">
        <div className="logo-container verum-logo-container" data-testid="verum-logo-container">
          <img 
            src={VERUM_LOGO} 
            alt="Verum Inventa" 
            className="company-logo verum-logo logo-pendulum logo-hover-target"
            data-testid="verum-logo"
          />
        </div>
        <div className="true-discovery-container" data-testid="true-discovery">
          <HandwrittenText text="True Discovery" baseDelay={1.2} className="hero-hw" />
        </div>
        <p className="since-text hero-since" data-testid="hero-since">Since 2018</p>
      </div>
    </div>
  </section>
);

export default HeroSection;
